import { render, staticRenderFns } from "./CampaignComponents.vue?vue&type=template&id=591270b2&"
import script from "./CampaignComponents.vue?vue&type=script&lang=ts&"
export * from "./CampaignComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports